import { cn } from "@/lib/utils"

// Small outline pills used under titles in the clip grid and list views.
// Tighter padding than the standard Badge primitive — tags are decorative,
// not lifecycle markers, so they read at a smaller size.
export function ClipTagPills({
  tags,
  className,
}: {
  tags: string[]
  className?: string
}) {
  if (tags.length === 0) return null
  return (
    <ul className={cn("flex flex-wrap items-center gap-1", className)}>
      {tags.map((tag) => (
        <li
          key={tag}
          className="inline-flex items-center whitespace-nowrap rounded-full border border-hairline px-1.5 py-0.5 text-[10px] leading-none text-ink-muted"
        >
          {tag}
        </li>
      ))}
    </ul>
  )
}
